<template>
  <tr>
    <td data-label="Name">
      <div class="d-sm-none">
        <br/>
        <p class="text-left mb-0 mt-2">
          {{ esmItem.name }}
        </p>
      </div>
      <span class="d-none d-sm-block">
        {{ esmItem.name }}
      </span>
    </td>
    <td data-label="Finding">
      <div class="d-sm-none">
        <br/>
        <p class="text-left mb-0 mt-2">
          {{ esmItem.finding }}
        </p>
      </div>
      <span class="d-none d-sm-block">
        {{ esmItem.finding }}
      </span>
    </td>
    <td class="button-2 text-center">
      <button class="my-2 btn btn-warning" @click="editEsmItem()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteEsmItem()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'EsmItemRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      esmItem () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      editEsmItem () {
        this.$emit('edit', { permalink: 'editEsmItem', uuid: this.esmItem.uuid })
      },
      deleteEsmItem () {
        this.$emit('deleteObject', { permalink: 'deleteEsmItem', uuid: this.esmItem.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/EsmItem.vue